module.exports = __webpack_public_path__ + "static/media/anchorage.79f1b5b3.svg";